export default __webpack_public_path__ + "static/media/projectDetails.7c8f42e6.png";